import * as React from 'react'

import { cn } from '#/shared/lib/utils'

type BadgeVariant = 'default' | 'success' | 'danger' | 'warning'

const BADGE_COLORS: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-500',
  success: 'bg-green-100 text-gray-500',
  danger: 'bg-red-100 text-gray-500',
  warning: 'bg-orange-100 text-gray-500',
}

const BADGE_ICON_COLORS: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-500',
  success: 'bg-green-100 text-green-500',
  danger: 'bg-red-100 text-red-500',
  warning: 'bg-orange-100 text-orange-400',
}

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
  children: React.ReactNode
}

function Badge({ variant = 'default', className, children, ...rest }: BadgeProps) {
  return (
    <span
      {...rest}
      className={cn(
        'flex h-6 shrink-0 items-center rounded-md px-2.5 text-sm',
        BADGE_COLORS[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}

interface BadgeIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
  children: React.ReactNode
}

function BadgeIcon({ variant = 'default', className, children, ...rest }: BadgeIconProps) {
  return (
    <span
      aria-hidden
      {...rest}
      className={cn(
        'flex size-6 shrink-0 items-center justify-center rounded-md text-sm leading-none',
        BADGE_ICON_COLORS[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}

export { Badge, BadgeIcon, BADGE_COLORS, BADGE_ICON_COLORS }
export type { BadgeProps, BadgeIconProps, BadgeVariant }
